class CocomelotShippingProgress extends HTMLElement {
  connectedCallback() {
    this.threshold = Number(this.dataset.threshold || 4900);
    document.addEventListener('cart:updated', () => this.refresh());
    this.refresh();
  }

  async refresh() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) return;
      const cart = await response.json();
      const remaining = Math.max(this.threshold - cart.total_price, 0);
      const ratio = Math.min(cart.total_price / this.threshold, 1);
      const bar = this.querySelector('[data-progress]');
      const message = this.querySelector('[data-message]');
      if (bar) bar.style.width = `${ratio * 100}%`;
      if (!message) return;

      if (remaining === 0) {
        message.textContent = 'Je bestelling wordt gratis verzonden.';
      } else {
        message.textContent = `Nog ${(remaining / 100).toLocaleString('nl-NL', {
          style: 'currency',
          currency: 'EUR',
        })} tot gratis verzending.`;
      }
    } catch (_error) {
      // The cart remains fully functional when the progress enhancement fails.
    }
  }
}

if (!customElements.get('cocomelot-shipping-progress')) {
  customElements.define('cocomelot-shipping-progress', CocomelotShippingProgress);
}

const loadProductCardSecondaryImage = (card) => {
  const image = card.querySelector('[data-cc-secondary-image]');
  if (!image || image.src) return;
  image.src = image.dataset.src;
  image.srcset = image.dataset.srcset;
  delete image.dataset.src;
  delete image.dataset.srcset;
};

if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('.cc-product-card__media').forEach((card) => {
    card.addEventListener('mouseenter', () => loadProductCardSecondaryImage(card), { once: true });
    card.addEventListener('focusin', () => loadProductCardSecondaryImage(card), { once: true });
  });
}
